<template>
  <div>
    <div class="info" v-if="!edit && !mover && !typer">
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      ></controls>

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
        <small class="has-text-grey-light">[{{ question.weight }}]</small>
      </h4>

      <div class="question-body">
        <div class="question-field">
          <div class="select mv1">
            <select disabled>
              <option>Location</option>
            </select>
          </div>
        </div>
        <div class="question-field">
          <div class="select mv1">
            <select disabled>
              <option>Practice</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
            />
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Weight</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select name="weight" v-model="data['weight']">
              <option v-for="weight in weights" v-bind:value="weight.value">
                [{{ weight.value }}] {{ weight.label }}
              </option>
            </select>
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Required</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select
              name="required"
              v-model="data['required']"
              :disabled="question.interviewMandatory"
            >
              <option v-for="required in yesNo" :value="required.value">
                {{ required.label }}
              </option>
            </select>
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field" v-for="(field, index) in data.fields">
          <label class="label">Location {{ index + 1 }}</label>
          <div class="columns ml-2">
            <div class="column">
              <div class="control has-icons-right mt-2">
                <input
                  type="text"
                  :class="[
                    'input',
                    { 'is-danger': errors[`location${index}`] }
                  ]"
                  v-model="field['location']"
                  name="location"
                  disabled
                />
                <span
                  class="icon is-small is-right"
                  v-if="errors[`location${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>
              <p v-if="errors[`location${index}`]" class="help is-danger">
                {{ errors[`location${index}`] }}
              </p>
            </div>
            <div class="column is-3 field-options">
              <div class="select">
                <select v-model="field['weight']">
                  <option
                    v-for="weight in fieldWeights"
                    v-bind:value="weight.value"
                  >
                    [{{ weight.value }}] {{ weight.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="providers">
            <div class="field" v-for="(provider, pIndex) in field['provider']">
              <label class="label">Provider {{ pIndex + 1 }}</label>
              <div class="columns">
                <div class="column">
                  <div class="control has-icons-right mt-2">
                    <input
                      :class="[
                        'input',
                        { 'is-danger': errors[`location${pIndex}`] }
                      ]"
                      v-model="provider['name']"
                      name="name"
                      disabled
                    />
                    <span
                      class="icon is-small is-right"
                      v-if="errors[`location${pIndex}`]"
                      ><i class="fa fa-warning"></i
                    ></span>
                  </div>
                  <p v-if="errors[`location${pIndex}`]" class="help is-danger">
                    {{ errors[`location${pIndex}`] }}
                  </p>
                </div>
                <div class="column is-3 field-options">
                  <div class="select">
                    <select v-model="provider['weight']">
                      <option
                        v-for="weight in fieldWeights"
                        v-bind:value="weight.value"
                      >
                        [{{ weight.value }}] {{ weight.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button type="button" class="button is-link" @click="hideEdit()">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move
      v-if="mover"
      :question="question"
      @hide="hideMove"
    ></question-move>
    <question-type
      v-if="typer"
      :question="question"
      @hide="hideTyper"
    ></question-type>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import RoutingRules from "../routing_rules/RoutingRules";

export default {
  name: "location",

  mixins: [baseQuestion]
};
</script>

<style lang="scss" scoped>
.field-options {
  align-self: center;
  justify-content: center;
}
</style>
